import { render } from "./FlagsTab.vue?vue&type=template&id=1afe96fc"
import script from "./FlagsTab.vue?vue&type=script&lang=js"
export * from "./FlagsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__